import { render, staticRenderFns } from "./FlashCardSelector.vue?vue&type=template&id=518d988a&scoped=true&"
import script from "./FlashCardSelector.vue?vue&type=script&lang=js&"
export * from "./FlashCardSelector.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardSelector.vue?vue&type=style&index=0&id=518d988a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d988a",
  null
  
)

export default component.exports